import React from 'react';

import { useTranslation } from 'react-i18next';
import { Tag, TagType } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from './suggested-domains.module.scss';

interface SuggestedDomainsProps {
	domains: string[];
	onAdd: (domain: string) => void;
}

export const SuggestedDomains: React.FC<SuggestedDomainsProps> = ({ domains, onAdd }) => {
	const { t } = useTranslation();

	if (!domains.length) return null;

	return (
		<div className={styles.suggestedDomains} data-test-id="suggested-domains">
			<span className={styles.suggestedLabel}>{t('SECURITY.ALLOWED_EMAIL_DOMAINS.SUGGESTED_DOMAINS_LABEL')}</span>
			<div className={styles.suggestedTags}>
				{domains.map(domain => (
					<Tag
						key={domain}
						type={TagType.info}
						className={styles.suggestedTag}
						onClick={() => onAdd(domain)}
						data-test-id={`suggested-domain-${domain}`}
					>
						<BringgIcon iconName={BringgFontIcons.Plus} className={styles.plusIcon} />
						{domain}
					</Tag>
				))}
			</div>
		</div>
	);
};
